import { memo, useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { useAppConfig, useSubscriptionTiersLoading } from '../contexts/SubscriptionTiersContext'
import { useLanguage } from '../contexts/LanguageContext'

const DEFAULT_TITLE = 'Limited Time Offer'
const DEFAULT_CODE = 'GETSTARTED'
const DEFAULT_OFFERS = '17 offers left'
const COPIED_MS = 2000

function PromoMadnessCardInner() {
  const { t } = useLanguage()
  const loading = useSubscriptionTiersLoading()
  const appConfig = useAppConfig()
  const copiedTimerRef = useRef(null)
  const [copied, setCopied] = useState(false)

  const code = useMemo(
    () => (appConfig?.promoMadnessCode && String(appConfig.promoMadnessCode).trim()) || DEFAULT_CODE,
    [appConfig],
  )

  const onCopy = useCallback(async () => {
    try {
      if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(code)
      } else {
        return
      }
      setCopied(true)
      if (copiedTimerRef.current != null) clearTimeout(copiedTimerRef.current)
      copiedTimerRef.current = window.setTimeout(() => {
        setCopied(false)
        copiedTimerRef.current = null
      }, COPIED_MS)
    } catch {
      /* clipboard denied or unavailable */
    }
  }, [code])

  useEffect(() => {
    return () => {
      if (copiedTimerRef.current != null) {
        clearTimeout(copiedTimerRef.current)
      }
    }
  }, [])

  if (loading || appConfig?.promoMadnessEnabled !== true) {
    return null
  }

  const title =
    (appConfig?.promoMadnessTitle && String(appConfig.promoMadnessTitle).trim()) || DEFAULT_TITLE
  const offersText =
    (appConfig?.promoMadnessOffersText && String(appConfig.promoMadnessOffersText).trim()) ||
    DEFAULT_OFFERS

  return (
    <div
      className="hero-top-banner__coupon hero-price-banner hero-coupon-banner hero-coupon-banner--account-offer promo-madness-card"
      role="region"
      aria-label={t('promoMadness.ariaRegion')}
    >
      <span className="hero-coupon-banner__text-wrap">
        <span className="hero-coupon-banner__text hero-coupon-banner__text--trial-headline">{title}</span>
        <div className="hero-coupon-banner__copy-card">
          <code
            className="hero-coupon-banner__copy-card-code"
            title={code}
            aria-label={`${t('promoMadness.codeAria')}: ${code}`}
          >
            {code}
          </code>
          <button type="button" className="hero-coupon-banner__copy-btn" aria-label={t('hero.createAccountPromoCopy')} onClick={onCopy}>
            {copied ? t('hero.createAccountPromoCopied') : t('hero.createAccountPromoCopy')}
          </button>
        </div>
        <p className="promo-madness-offers-text">{offersText}</p>
      </span>
    </div>
  )
}

export const PromoMadnessCard = memo(PromoMadnessCardInner)
